/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S10_Li3_BInputs */

const tr_mesafeli_s10_li3_b = /** @type {(inputs: Mesafeli_S10_Li3_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ekranından istediği zaman güncelleyebilir veya silebilir.`)
};

const en_mesafeli_s10_li3_b = /** @type {(inputs: Mesafeli_S10_Li3_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`update or delete these keys.`)
};

const de_mesafeli_s10_li3_b = /** @type {(inputs: Mesafeli_S10_Li3_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktualisieren oder löschen.`)
};

const ru_mesafeli_s10_li3_b = /** @type {(inputs: Mesafeli_S10_Li3_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`обновить или удалить эти ключи.`)
};

/**
* | output |
* | --- |
* | "update or delete these keys." |
*
* @param {Mesafeli_S10_Li3_BInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s10_li3_b = /** @type {((inputs?: Mesafeli_S10_Li3_BInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S10_Li3_BInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s10_li3_b(inputs)
	if (locale === "de") return de_mesafeli_s10_li3_b(inputs)
	if (locale === "ru") return ru_mesafeli_s10_li3_b(inputs)
	return tr_mesafeli_s10_li3_b(inputs)
});